export default {
  data() {
    return {
      searchSchema: [
        {
          label: '评分卡名称',
          type: 'input',
          itemName: 'cardName',
          allowClear: true,
        },
      ],
      searchForm: {
        cardName: '',
      },
      pageData: {
        pageSize: 10,
        current: 1,
        total: 0,
        showTotal: total => `共${total}条`,
      },
      tableData: [],

      searchTargetType: [
        {
          label: '指标类型',
          type: 'input',
          itemName: 'type',
          allowClear: true,
        },
      ],
      searchTargetForm: {
        type: '',
      },
      chooseData: [],

      tableColumns: [
        {
          fixed: 'left',
          title: '序号',
          width: 60,
          align: 'center',
          customRender: (text, record, index) => {
            return (
              (this.pageData.current - 1) * this.pageData.pageSize + index + 1
            )
          },
        },
        {
          title: '评分卡名称',
          // width: 180,
          dataIndex: 'cardName',
        },
        {
          title: '包含指标数',
          width: 120,
          dataIndex: 'targetNum',
          align: 'center',
        },
        {
          title: '被引用次数',
          width: 120,
          dataIndex: 'targetUsed',
          align: 'center',
          scopedSlots: { customRender: 'targetUsed' },
        },
        {
          title: '编辑时间',
          width: 160,
          dataIndex: 'createTime',
          align: 'center',
        },
        {
          title: '编辑人名称',
          width: 160,
          dataIndex: 'name',
          align: 'center',
        },
        {
          title: '状态',
          width: 120,
          dataIndex: 'freeze',
          scopedSlots: { customRender: 'freeze' },
          align: 'center',
        },
        {
          title: '操作',
          width: 200,
          align: 'center',
          fixed: 'right',
          scopedSlots: { customRender: 'action' },
        },
      ],
      // 资产负债指标
      propertyKey: [
        10000,
        1200001,
        1000001,
        1000002,
        20000,
        20001,
        20002,
        30000,
        30001,
        40000,
        3000001,
        3000002,
        3000003,
        3000004,
        3000005,
        3000006,
      ], // 默认展开
      expandedKey: [],
      selectedPropertyKeys: [], // 选中
      propertyTrees: [
        {
          targetName: '批量导入指标',
          id: 1200001,
          chooseType: '120',
          children: [],
        },
        {
          targetName: '成长能力指标',
          id: 20001,
          chooseType: '444',
          children: [],
        },
      ],
      // 财务分析指标
      lossTrees: [
        {
          targetName: '主要财务指标',
          id: 20002,
          chooseType: '111',
          children: [],
        },
        {
          targetName: '盈利能力指标',
          id: 20000,
          chooseType: '222',
          children: [],
        },
      ],
      // 财务分析指标
      cashTrees: [
        {
          targetName: '偿债能力指标',
          id: 30000,
          chooseType: '333',
          children: [],
        },
        {
          targetName: '运营能力指标',
          id: 30001,
          chooseType: '555',
          children: [],
        },
      ],
      // 非财务指标
      nonFinancialTrees: [
        {
          targetName: '非财务指标',
          id: 40000,
          chooseType: '050101',
          children: [],
        },
      ],
    }
  },
  methods: {
    // 查询
    handleSearch(data) {
      this.searchForm = { ...this.searchForm, ...data }
      this.pageData.current = 1
      this._getTableData()
    },
    // 点击分页按钮
    handleClickPage({ current, pageSize }) {
      this.pageData = { ...this.pageData, current, pageSize }
      this._getTableData()
    },

    // 修改权重
    changeWeight() {
      var sumWeight = 0
      this.targetList.forEach(item => {
        sumWeight = sumWeight + Number(item.targetWeight)
      })
      this.weightAll = 100 - sumWeight
    },

    handleDragStart(e, item) {
      this.dragging = item
    },
    // div拖动更换顺序 - 始
    handleDragEnd(e, item) {
      console.log(e + '-' + JSON.stringify(item))
      if (this.ending.id === this.dragging.id) {
        return
      }
      let newItems = [...this.targetList]
      const src = newItems.indexOf(this.dragging)
      const dst = newItems.indexOf(this.ending)
      newItems.splice(src, 1, ...newItems.splice(dst, 1, newItems[src]))
      console.log(newItems)

      this.targetList = newItems
      this.$nextTick(() => {
        this.dragging = null
        this.ending = null
      })
    },
    handleDragOver(e) {
      // 首先把div变成可以放置的元素，即重写dragenter/dragover
      e.dataTransfer.dropEffect = 'move' // e.dataTransfer.dropEffect="move";//在dragenter中针对放置目标来设置!
    },
    handleDragEnter(e, item) {
      e.dataTransfer.effectAllowed = 'move' // 为需要移动的元素设置dragstart事件
      this.ending = item
    },
    // div拖动更换顺序 - 终
    // 点击选择指标
    getTargetTableList() {
      this.selectedPropertyKeys = []
      this.chooseTarget = true
      // 资产负债指标树
      this.pushDisable(this.propertyTrees)
      // 损益指标树
      this.pushDisable(this.lossTrees)
      //现金流量指标树
      this.pushDisable(this.cashTrees)
      //非财务指标树
      this.pushDisable(this.nonFinancialTrees)
      // 回显已选择的
      if (this.targetList.length > 0) {
        this.targetList.forEach(item => {
          if (item.targetChooseId) {
            this.selectedPropertyKeys.push(item.targetChooseId)
          } else {
            this.selectedPropertyKeys.push(item.id)
          }
        })
        // 记录已选择的节点
        var nodeList = []
        this.selectPropertyNodeList = this.pushTree(
          this.propertyTrees,
          nodeList,
        )
        var nodeList1 = []
        this.selectLossNodeList = this.pushTree(this.lossTrees, nodeList1)
        var nodeList2 = []
        this.selectCashNodeList = this.pushTree(this.cashTrees, nodeList2)
        var nodeList3 = []
        this.selectNonFinancialNodeList = this.pushTree(
          this.nonFinancialTrees,
          nodeList3,
        )
      }
      // 设置展开
      this.expandedKey = []
      this.expandedKey = this.expandedKey.concat(this.propertyKey)
      if (this.selectedPropertyKeys.length > 0) {
        this.expandedKey = this.expandedKey.concat(this.selectedPropertyKeys)
      }
    },

    // 选择指标弹窗关闭
    handleAfterChooseClose() {
      this.chooseTarget = false
    },
    // 选择完指标提交
    handleSubmitTarget() {
      let checkTargetList = []
      if (this.selectPropertyNodeList.length > 0) {
        checkTargetList = checkTargetList.concat(this.selectPropertyNodeList)
      }
      if (this.selectLossNodeList.length > 0) {
        checkTargetList = checkTargetList.concat(this.selectLossNodeList)
      }
      if (this.selectCashNodeList.length > 0) {
        checkTargetList = checkTargetList.concat(this.selectCashNodeList)
      }
      if (this.selectNonFinancialNodeList.length > 0) {
        checkTargetList = checkTargetList.concat(
          this.selectNonFinancialNodeList,
        )
      }
      if (checkTargetList.length == 0) {
        this.$notification.warning({
          message: '提示',
          description: '未选择任何指标',
        })
        return false
      }
      checkTargetList.forEach(item => {
        if (!item.customTargetRangeList) {
          // 检查是否已选择过，若选择过将之前的分值区间复制一份
          const listIndex = this.targetList.findIndex(
            a => a.id == item.id || a.targetChooseId == item.id,
          )
          if (listIndex > -1) {
            item.customTargetRangeList = this.targetList[
              listIndex
            ].customTargetRangeList
            item.targetWeight = this.targetList[listIndex].targetWeight
          } else {
            item.customTargetRangeList = []
            item.targetWeight = 0
          }
        }
      })
      // 财务指标数、非财务指标数
      this.financeTargetNum =
        this.selectPropertyNodeList.length +
        this.selectLossNodeList.length +
        this.selectCashNodeList.length
      this.noFinancetargetNum = this.selectNonFinancialNodeList.length
      this.targetList = checkTargetList
      console.log('指标列表' + JSON.stringify(this.targetList))
      this.chooseTarget = false
      this.changeWeight()
    },
    pushTree(tree, check) {
      for (let i = 0; i < tree.length; i++) {
        const node = tree[i]
        const nodeIndex = this.targetList.findIndex(
          a => a.id == node.id || Number(a.targetChooseId) == node.id,
        )
        if (nodeIndex > -1) {
          check.push(node)
        }
        if (node.children) {
          this.pushTree(node.children, check)
        }
      }
      return check
    },
    // 树递归
    pushDisable(tree) {
      for (let i = 0; i < tree.length; i++) {
        const node = tree[i]
        if (node.children && node.children.length == 0) {
          node.children = this.propertyTree.filter(item => {
            return item.titleType == node.chooseType
          })
        }
        if (node.children) {
          tree[i] = Object.assign({}, tree[i], {
            disabled: true,
          })
          this.pushDisable(node.children)
        }
      }
    },

    // 选中树节点
    checkPropertyTree(checkedKeys, info) {
      console.log('checkedKeys:' + JSON.stringify(checkedKeys))
      this.selectPropertyNodeList = []
      info.checkedNodes.forEach(item => {
        this.selectPropertyNodeList.push(item.data.props.dataRef)
      })
      console.log('资产负债指标:' + JSON.stringify(this.selectPropertyNodeList))
    },
    checkLossTree(checkedKeys, info) {
      console.log('checkedKeys:' + JSON.stringify(checkedKeys))
      this.selectLossNodeList = []
      info.checkedNodes.forEach(item => {
        this.selectLossNodeList.push(item.data.props.dataRef)
      })
      console.log('损益指标:' + JSON.stringify(this.selectLossNodeList))
    },
    checkCashTree(checkedKeys, info) {
      console.log('checkedKeys:' + JSON.stringify(checkedKeys))
      this.selectCashNodeList = []
      info.checkedNodes.forEach(item => {
        this.selectCashNodeList.push(item.data.props.dataRef)
      })
      console.log('现金流指标:' + JSON.stringify(this.selectCashNodeList))
    },
    checknonFinancialTree(checkedKeys, info) {
      console.log('checkedKeys:' + JSON.stringify(checkedKeys))
      this.selectNonFinancialNodeList = []
      info.checkedNodes.forEach(item => {
        this.selectNonFinancialNodeList.push(item.data.props.dataRef)
      })
      console.log(
        '现金流指标:' + JSON.stringify(this.selectNonFinancialNodeList),
      )
    },

    // 删除已选中的指标
    deleteTargetList(item) {
      let index = this.targetList.indexOf(item)
      if (index !== -1) {
        this.targetList.splice(index, 1)
      }
      // 修改财务、非财务指标数量
      if (item.targetType == '1') {
        this.financeTargetNum = this.financeTargetNum - 1
      } else {
        this.noFinancetargetNum = this.noFinancetargetNum - 1
      }
      // 修改权重
      this.changeWeight()
    },
    // 提交分值区间
    handleSubmitSetting() {
      // 校验分值区间是否填写完整，符合规则
      if (this.settingForm.dataType == '1') {
        for (var i = 0; i < this.scoreResultList.length; i++) {
          if (i == 0) {
            if (
              this.scoreResultList[i].maxScore == null ||
              this.scoreResultList[i].maxScore == undefined
            ) {
              this.$notification.warning({
                message: '提示',
                description: '请将第' + (i + 1) + '行最大值补充完整',
              })
              return false
            }
          } else if (i == this.scoreResultList.length - 1) {
            if (
              this.scoreResultList[i].minScore == null ||
              this.scoreResultList[i].minScore == undefined
            ) {
              this.$notification.warning({
                message: '提示',
                description: '请将第' + (i + 1) + '行最小值补充完整',
              })
              return false
            }
            // 校验最后一行最小值是否与上一行最大值相同
            if (
              this.scoreResultList[i].minScore !=
              this.scoreResultList[i - 1].maxScore
            ) {
              this.$notification.warning({
                message: '提示',
                description:
                  '第' + (i + 1) + '行最小值必须等于第' + i + '行的最大值',
              })
              return false
            }
          } else {
            if (
              this.scoreResultList[i].minScore == null ||
              this.scoreResultList[i].minScore == undefined
            ) {
              this.$notification.warning({
                message: '提示',
                description: '请将第' + (i + 1) + '行最小值补充完整',
              })
              return false
            }
            if (
              this.scoreResultList[i].maxScore == null ||
              this.scoreResultList[i].maxScore == undefined
            ) {
              this.$notification.warning({
                message: '提示',
                description: '请将第' + (i + 1) + '行最大值补充完整',
              })
              return false
            }
            // 校验本行最小值必须大于最大值
            if (
              parseFloat(this.scoreResultList[i].minScore) >=
              parseFloat(this.scoreResultList[i].maxScore)
              // this.scoreResultList[i].minScore >=
              // this.scoreResultList[i].maxScore
            ) {
              this.$notification.warning({
                message: '提示',
                description: '第' + (i + 1) + '行最小值必须小于最大值',
              })
              return false
            }
            // 校验本行最小值是否与上一行最大值相同
            if (
              this.scoreResultList[i].minScore !=
              this.scoreResultList[i - 1].maxScore
            ) {
              this.$notification.warning({
                message: '提示',
                description:
                  '第' + (i + 1) + '行最小值必须等于第' + i + '行的最大值',
              })
              return false
            }
          }
          // 校验分值是否填写
          if (
            this.scoreResultList[i].targetScore == null ||
            this.scoreResultList[i].targetScore == undefined
          ) {
            this.$notification.warning({
              message: '提示',
              description: '请将第' + (i + 1) + '行的分值补充完整',
            })
            return false
          }
        }
      } else {
        for (var j = 0; j < this.scoreResultList.length; j++) {
          // 校验分值是否填写
          if (
            this.scoreResultList[j].targetScore == null ||
            this.scoreResultList[j].targetScore == undefined
          ) {
            this.$notification.warning({
              message: '提示',
              description:
                '请将第' +
                (j + 1) +
                '行' +
                this.scoreResultList[j].targetName +
                '分值补充完整',
            })
            return false
          }
        }
      }
      this.targetList[
        this.settingIndex
      ].customTargetRangeList = this.scoreResultList
      this.settingTarget = false
    },
    // 关闭分值区间
    handleSettingClose() {
      this.settingTarget = false
    },
    // 新增一行
    addScoreResult() {
      this.scoreResultList.push({
        minScore: null,
        maxScore: null,
        targetScore: null,
        targetId: '',
        targetName: '',
        key: Date.now(),
      })
    },
    // 删除分值区间
    removeScoreResult(item) {
      let index = this.scoreResultList.indexOf(item)
      if (index !== -1) {
        this.scoreResultList.splice(index, 1)
      }
    },
  },
}
